import { Routes } from "@angular/router";
import { PropertyServiceGuard } from "./guards/propertyService/property-service.guard";
import { AuthGuard } from "./handlers/auth.guard";
import { PropBookletPageComponent } from "./pages/property/prop-booklet-page/prop-booklet-page.component";
import { PropBuildingPageComponent } from "./pages/property/prop-building-page/prop-building-page.component";
import { PropCondoPageComponent } from "./pages/property/prop-condo-page/prop-condo-page.component";
import { PropConsumptionPageComponent } from "./pages/property/prop-consumption-page/prop-consumption-page.component";
import { PropEnergyPageComponent } from "./pages/property/prop-energy-page/prop-energy-page.component";
import { PropEquipmentPageComponent } from "./pages/property/prop-equipment-page/prop-equipment-page.component";
import { PropFicheSecoursPageComponent } from "./pages/property/prop-fiche-secours-page/prop-fiche-secours-page.component";
import { PropFinancialPageComponent } from "./pages/property/prop-financial-page/prop-financial-page.component";
import { PropLocationPageComponent } from "./pages/property/prop-location-page/prop-location-page.component";
import { PropMaintenancePageComponent } from "./pages/property/prop-maintenance-page/prop-maintenance-page.component";
import { PropPeoplePageComponent } from "./pages/property/prop-people-page/prop-people-page.component";
import { PropPhotosPageComponent } from "./pages/property/prop-photos-page/prop-photos-page.component";
import { PropSalePageComponent } from "./pages/property/prop-sale-page/prop-sale-page.component";
import { PropServicesPageComponent } from "./pages/property/prop-services-page/prop-services-page.component";
import { PropSharesPageComponent } from "./pages/property/prop-shares-page/prop-shares-page.component";
import { PropTimelinePageComponent } from "./pages/property/prop-timeline-page/prop-timeline-page.component";
import { PropTrackingFinancialPageComponent } from "./pages/property/prop-tracking-financial-page/prop-tracking-financial-page.component";
import { PropVaultPageComponent } from "./pages/property/prop-vault-page/prop-vault-page.component";
import { PropWorkPageComponent } from "./pages/property/prop-work-page/prop-work-page.component";
import { MenuToNativeId } from "./services/bridge/bridge.service";
import { AdminComponent } from "./views/admin/admin-nav/admin.component";
import { ConnectorsComponent } from "./views/connectors/connectors.component";
import { ContactsComponent } from "./views/contacts/contacts.component";
import { DropboxComponent } from "./views/dropbox/dropbox.component";
import { HelpComponent } from "./views/help/help.component";
import { HomeComponent } from "./views/home/home.component";
import { KpisComponent } from "./views/kpis/kpis.component";
import { NotFoundComponent } from "./views/not-found/not-found.component";
import { NotificationsComponent } from "./views/notifications/notifications.component";
import { ProfileComponent } from "./views/profile/profile.component";
import { CondoManagementComponent } from "./views/property/condo-management/condo-management.component";
import { PropertyInfosComponent } from "./views/property/property-infos/property-infos.component";
import { PropertyMainComponent } from "./views/property/property-main/property-main.component";
import { PropertyVCardComponent } from "./views/property/property-vcard/property-vcard.component";
import { PropertyComponent } from "./views/property/property/property.component";
import { EmailValidationComponent } from "./views/public/email-validation/email-validation.component";
import { LoginCallbackComponent } from "./views/public/login-callback/login-callback.component";
import { LoginGuestComponent } from "./views/public/login-guest/login-guest.component";
import { LoginComponent } from "./views/public/login/login.component";
import { LogoutComponent } from "./views/public/logout/logout.component";
import { PasswordLostComponent } from "./views/public/password-lost/password-lost.component";
import { RegisterComponent } from "./views/public/register/register.component";
import { SharesComponent } from "./views/shares/shares.component";
import { TrackingComponent } from "./views/tracking/tracking/tracking.component";

export interface DataPage {
  level: number;
  page: MenuToNativeId;
  uid: string;
}

export const appRoutes: Routes = [
  // authenticated routes
  {
    path: "home",
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: { level: 1, page: MenuToNativeId.HOME_PROPERTY } as DataPage,
  },
  {
    path: "property/vcard/:eemoId",
    component: PropertyVCardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "property/:uid/feedback/:sharingUid",
    component: PropertyComponent,
    canActivate: [AuthGuard],
    data: { level: 2, page: MenuToNativeId.PROP_MAIN } as DataPage,
  },
  {
    path: "property/:uid",
    component: PropertyComponent,
    data: { level: 2, page: MenuToNativeId.PROP_MAIN } as DataPage,
    canActivate: [AuthGuard],
    children: [
      {
        path: "main",
        component: PropertyMainComponent,
        data: { level: 2, page: MenuToNativeId.PROP_MAIN } as DataPage,
      },
      {
        path: "booklet",
        component: PropBookletPageComponent,
        data: { level: 2, page: MenuToNativeId.BOOKLET } as DataPage,
      },
      {
        path: "sale",
        component: PropSalePageComponent,
        data: { level: 2, page: MenuToNativeId.PROP_SALE } as DataPage,
      },
      {
        path: "infos",
        component: PropertyInfosComponent,
        data: { level: 2, page: MenuToNativeId.PROP_INFO } as DataPage,
      },
      {
        component: PropFicheSecoursPageComponent,
        path: "rescue",
        data: { level: 3, page: MenuToNativeId.FICHE_SECOURS } as DataPage,
      },
      {
        component: PropLocationPageComponent,
        path: "location",
        data: { level: 3, page: MenuToNativeId.LOCATION } as DataPage,
      },
      {
        component: PropBuildingPageComponent,
        path: "building",
        data: { level: 3, page: MenuToNativeId.BUILDING } as DataPage,
      },
      {
        component: PropEnergyPageComponent,
        path: "energy",
        data: { level: 3, page: MenuToNativeId.ENERGY } as DataPage,
      },
      {
        component: PropFinancialPageComponent,
        path: "financial",
        data: { level: 3, page: MenuToNativeId.FINANCIAL } as DataPage,
      },
      {
        component: PropPeoplePageComponent,
        path: "people",
        data: { level: 3, page: MenuToNativeId.PEOPLE } as DataPage,
      },
      {
        component: PropCondoPageComponent,
        path: "condo",
        data: { level: 3, page: MenuToNativeId.CONDOMINIUM } as DataPage,
      },
      {
        path: "photos",
        component: PropPhotosPageComponent,
        data: { level: 2, page: MenuToNativeId.PHOTO } as DataPage,
      },
      {
        component: PropEquipmentPageComponent,
        path: "equipments",
        data: { level: 2, page: MenuToNativeId.EQUIPMENT } as DataPage,
      },
      {
        path: "tracking",
        component: TrackingComponent,
        data: { level: 2, page: MenuToNativeId.TRACKING } as DataPage,
      },
      {
        component: PropTimelinePageComponent,
        path: "timeline",
        data: { level: 3, page: MenuToNativeId.TIMELINE } as DataPage,
      },
      {
        component: PropConsumptionPageComponent,
        path: "consumption",
        data: { level: 3, page: MenuToNativeId.CONSUMPTION } as DataPage,
      },
      {
        component: PropMaintenancePageComponent,
        path: "maintenance",
        data: { level: 3, page: MenuToNativeId.MAINTENANCE } as DataPage,
      },
      {
        component: PropWorkPageComponent,
        path: "work",
        data: { level: 3, page: MenuToNativeId.WORK } as DataPage,
      },
      {
        component: PropTrackingFinancialPageComponent,
        path: "tracking-financial",
        data: { level: 3, page: MenuToNativeId.TRACKING_FINANCIAL } as DataPage,
      },
      {
        path: "vault",
        component: PropVaultPageComponent,
        data: { level: 2, page: MenuToNativeId.VAULT } as DataPage,
      },
      {
        path: "shares",
        component: PropSharesPageComponent,
        data: { level: 2, page: MenuToNativeId.PROP_SHARES } as DataPage,
      },
      {
        path: "services",
        component: PropServicesPageComponent,
        data: { level: 2, page: MenuToNativeId.PROP_SERVICES } as DataPage,
        canActivate: [PropertyServiceGuard],
      },
      { path: "", redirectTo: "main", pathMatch: "full" },
    ],
  },
  {
    path: "condo-mngt/:uid",
    component: CondoManagementComponent,
    canActivate: [AuthGuard],
    data: { level: 1, page: MenuToNativeId.MAIN_CONDO } as DataPage,
  },
  {
    path: "shares",
    component: SharesComponent,
    canActivate: [AuthGuard],
    data: { level: 1, page: MenuToNativeId.SHARES } as DataPage,
  },
  {
    path: "admin",
    component: AdminComponent,
    canActivate: [AuthGuard],
    data: { level: 1, page: MenuToNativeId.ADMIN } as DataPage,
  },
  {
    path: "profile",
    component: ProfileComponent,
    canActivate: [AuthGuard],
    data: { level: 1, page: MenuToNativeId.PROFILE } as DataPage,
  },
  {
    path: "dropbox",
    component: DropboxComponent,
    canActivate: [AuthGuard],
    data: { level: 1, page: MenuToNativeId.DROPBOX } as DataPage,
  },
  {
    path: "kpi",
    component: KpisComponent,
    canActivate: [AuthGuard],
    data: { level: 1, page: MenuToNativeId.KPIS } as DataPage,
  },
  {
    path: "connectors",
    component: ConnectorsComponent,
    canActivate: [AuthGuard],
    data: { level: 1, page: MenuToNativeId.CONNECTORS } as DataPage,
  },
  {
    path: "contacts",
    component: ContactsComponent,
    canActivate: [AuthGuard],
    data: { level: 1, page: MenuToNativeId.CONTACTS } as DataPage,
  },
  {
    path: "notifications",
    component: NotificationsComponent,
    canActivate: [AuthGuard],
    data: { level: 1, page: MenuToNativeId.NOTIFICATIONS } as DataPage,
  },
  {
    path: "notifications/:uid",
    component: NotificationsComponent,
    canActivate: [AuthGuard],
    data: { level: 1, page: MenuToNativeId.NOTIFICATIONS } as DataPage,
  },
  {
    path: "help",
    component: HelpComponent,
    canActivate: [AuthGuard],
    data: { level: 1, page: MenuToNativeId.HELP } as DataPage,
  },
  // public routes
  { path: "login", component: LoginComponent },
  { path: "login/callback", component: LoginCallbackComponent },
  { path: "login/guest", component: LoginGuestComponent },
  { path: "logout", component: LogoutComponent },
  { path: "register", component: RegisterComponent },
  { path: "password-lost", component: PasswordLostComponent },
  {
    path: "users/:uid/email-validate/:key",
    component: EmailValidationComponent,
  },

  { path: "", redirectTo: "/home", pathMatch: "full" },
  // otherwise redirect to not found
  { path: "**", component: NotFoundComponent, canActivate: [AuthGuard] },
];
